// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"0e6d7aad","453":"66221808"}[chunkId] + ".chunk.js";
};